import React from 'react';

// 1. Import all the exercise components
import FlyersReadingPart1 from './exercises/FlyersReadingPart1.js';
import FlyersReadingPart2 from './exercises/FlyersReadingPart2.js';
import FlyersReadingPart3 from './exercises/FlyersReadingPart3.js';
import FlyersReadingPart4 from './exercises/FlyersReadingPart4.js';
import FlyersReadingPart5 from './exercises/FlyersReadingPart5.js';
import FlyersReadingPart6 from './exercises/FlyersReadingPart6.js';
import FlyersReadingPart7 from './exercises/FlyersReadingPart7.js';
import FlyersListenPart1 from './exercises/FlyersListenPart1.js';
import FlyersListenPart2 from './exercises/FlyersListenPart2.js';
import FlyersListenPart3 from './exercises/FlyersListenPart3.js';
import FlyersListenPart4 from './exercises/FlyersListenPart4.js';
import FlyersListenPart5 from './exercises/FlyersListenPart5.js';
import MoversListenPart3 from './exercises/MoversListenPart3.js';
import MoversReadingPart1 from './exercises/MoversReadingPart1.js';
import MoversReadingPart2 from './exercises/MoversReadingPart2.js';
import MoversReadingPart3 from './exercises/MoversReadingPart3.js';
import MoversReadingPart4 from './exercises/MoversReadingPart4.js';
import MoversReadingPart5 from './exercises/MoversReadingPart5.js';
import MoversReadingPart6 from './exercises/MoversReadingPart6.js';
import MoversReadingPart7 from './exercises/MoversReadingPart7.js';
import MoversListenPart1 from './exercises/MoversListenPart1.js';
import MoversListenPart2 from './exercises/MoversListenPart2.js';
import MoversListenPart4 from './exercises/MoversListenPart4.js';
import MoversListenPart5 from './exercises/MoversListenPart5.js';
import StartersReadingPart1 from './exercises/StartersReadingPart1.js';
import StartersReadingPart2 from './exercises/StartersReadingPart2.js';
import StartersReadingPart3 from './exercises/StartersReadingPart3.js';
import StartersReadingPart4 from './exercises/StartersReadingPart4.js';
import StartersReadingPart5 from './exercises/StartersReadingPart5.js';
import StartersReadingPart6 from './exercises/StartersReadingPart6.js';
import StartersReadingPart7 from './exercises/StartersReadingPart7.js';
import StartersListenPart1 from './exercises/StartersListenPart1.js';
import StartersListenPart2 from './exercises/StartersListenPart2.js';
import StartersListenPart3 from './exercises/StartersListenPart3.js';
import StartersListenPart4 from './exercises/StartersListenPart4.js';
import ExerciseHeader from './common/ExerciseHeader.js';

// 2. Create the component map
const exerciseComponentMap = {
  'reading_writing_flyer_part_1': FlyersReadingPart1,
  'reading_writing_flyer_part_2': FlyersReadingPart2,
  'reading_writing_flyer_part_3': FlyersReadingPart3,
  'reading_writing_flyer_part_4': FlyersReadingPart4,
  'reading_writing_flyer_part_5': FlyersReadingPart5,
  'reading_writing_flyer_part_6': FlyersReadingPart6,
  'reading_writing_flyer_part_7': FlyersReadingPart7,
  'listen_flyer_part_1': FlyersListenPart1,
  'listen_flyer_part_2': FlyersListenPart2,
  'listen_flyer_part_3': FlyersListenPart3,
  'listen_flyer_part_4': FlyersListenPart4,
  'listen_flyer_part_5': FlyersListenPart5,
  'listen_mover_part_3': MoversListenPart3,
  'listen_movers_part_3': MoversListenPart3,
  'reading_writing_movers_part_1': MoversReadingPart1,
  'reading_writing_movers_part_2': MoversReadingPart2,
  'reading_writing_movers_part_3': MoversReadingPart3,
  'reading_writing_movers_part_4': MoversReadingPart4,
  'reading_writing_movers_part_5': MoversReadingPart5,
  'reading_writing_movers_part_6': MoversReadingPart6,
  'reading_writing_movers_part_7': MoversReadingPart7,
  'listen_movers_part_1': MoversListenPart1,
  'listen_mover_part_1': MoversListenPart1,
  'listen_movers_part_2': MoversListenPart2,
  'listen_mover_part_2': MoversListenPart2,
  'listen_movers_part_4': MoversListenPart4,
  'listen_mover_part_4': MoversListenPart4,
  'listen_movers_part_5': MoversListenPart5,
  'listen_mover_part_5': MoversListenPart5,
  'reading_writing_starters_part_1': StartersReadingPart1,
  'reading_writing_starters_part_2': StartersReadingPart2,
  'reading_writing_starters_part_3': StartersReadingPart3,
  'reading_writing_starters_part_4': StartersReadingPart4,
  'reading_writing_starters_part_5': StartersReadingPart5,
  'reading_writing_starters_part_6': StartersReadingPart6,
  'reading_writing_starters_part_7': StartersReadingPart7,
  'listen_starters_part_1': StartersListenPart1,
  'listen_starters_part_2': StartersListenPart2,
  'listen_starters_part_3': StartersListenPart3,
  'listen_starters_part_4': StartersListenPart4,
};

const ExerciseView = ({ exercise, attemptId, showHint, isReviewMode }) => {
  if (!exercise) {
    return <p>Loading exercise...</p>;
  }

  const ExerciseComponent = exerciseComponentMap[exercise.layout_type || exercise.type];

  if (!ExerciseComponent) {
    return (
      <div>
        <div className="error-message">Error: Unsupported exercise type "{exercise.type}"</div>
        <pre>{JSON.stringify(exercise, null, 2)}</pre>
      </div>
    );
  }

  const { part_label, question_count_label, instruction, story_text, audio_url } = exercise.content_data;

  return (
    <div className="exercise-view">
      <ExerciseHeader
        part_label={part_label}
        question_count_label={question_count_label}
        instruction={instruction}
        story_text={story_text}
        audio_url={audio_url}
        ASSET_BASE_URL={process.env.REACT_APP_ASSET_URL}
      />
      <ExerciseComponent
        key={exercise.id}
        attemptId={attemptId}
        exerciseId={exercise.id}
        exerciseData={exercise}
        showHint={showHint}
        isReviewMode={isReviewMode}
      />
    </div>
  );
};

export default ExerciseView;
